import React, { Component } from "react";

class Passed extends Component {
    render() {
        return (
            <div className="overLay">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-8">
                            <div className="card mt-7">
                                <div className="card-body text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-10 col-xl-8 ">
                                            <img
                                                src="/images/passedPage.png"
                                                alt=""
                                                className="img-fluid  mb-4"
                                                style={{
													marginLeft : "100px",
                                                    marginTop: "-100px"
                                                }}
                                            ></img>
                                            <h2 className="text-muted">
                                                Congratulations, you passed!
                                            </h2>
                                            <p class="text-muted">
                                                You are eligible for taking the next steps with your ProWriter portfolio.
                                            </p>
                                            <button
                                                onClick={this.props.home}
                                                className="btn btn-primary"
                                            >
                                                Continue
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Passed;



// WEBPACK FOOTER //
// ./src/components/writer/quiz/Passed.js